var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('b-progress',{staticClass:"mt-3",attrs:{"value":100,"variant":"info","striped":"","animated":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }